import { render, staticRenderFns } from "./ThemeSynth.vue?vue&type=template&id=7bb8e5c2&scoped=true&"
import script from "./ThemeSynth.vue?vue&type=script&lang=js&"
export * from "./ThemeSynth.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSynth.vue?vue&type=style&index=0&id=7bb8e5c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8e5c2",
  null
  
)

export default component.exports